import { Users, StickyNote, Repeat } from 'lucide-react';
import { STAVY, cas, cil, denDlouze, oknoPopis } from './rezervaceUi';
import { SECTION_COLOR, SECTION_BG } from '../objednavky/ui';

/**
 * Rezervace jako řádky po dnech — navigační seznam. Kreslí se v pohledu
 * Seznam, v zúženém sloupci vedle detailu a na telefonu (osa ani týden se
 * do úzkého sloupce nevejdou a seznam je tam navigace, ne přehled).
 */
export default function SeznamRezervaci({ rezervace, isMobile, borderColor, mutedColor, vybranyId = null, onOtevrit, prazdne = 'V tomhle období nic není.' }) {
    if (!rezervace.length) {
        return <p className="text-center text-sm" style={{ color: mutedColor, padding: '32px 16px' }}>{prazdne}</p>;
    }

    const dny = new Map();
    for (const r of [...rezervace].sort((a, b) => a.zacatek.localeCompare(b.zacatek))) {
        if (!dny.has(r.datum)) dny.set(r.datum, []);
        dny.get(r.datum).push(r);
    }

    return [...dny.entries()].map(([datum, radky]) => {
        const platne = radky.filter(r => r.stav !== 'zrusena');
        const hostu = platne.reduce((n, r) => n + r.pocet_hostu, 0);
        return (
            <div key={datum}>
                <div className="flex justify-between" style={{ padding: '10px 14px 6px', fontSize: 10.5, fontWeight: 700, letterSpacing: '.08em', textTransform: 'uppercase', color: mutedColor, borderBottom: `1px solid ${borderColor}`, gap: 10 }}>
                    <span className="truncate">{denDlouze(datum)}</span>
                    <span style={{ fontVariantNumeric: 'tabular-nums' }}>{platne.length} · {hostu} hostů</span>
                </div>
                {radky.map(r => {
                    const s = STAVY[r.stav] || STAVY.potvrzena;
                    const vybrany = r.id === vybranyId;
                    return (
                        <button key={r.id} type="button" onClick={() => onOtevrit(r)}
                            className="w-full flex items-center text-left"
                            style={{
                                gap: 12, padding: isMobile ? '10px 16px' : '9px 14px', minHeight: isMobile ? 60 : 52,
                                border: 'none', borderBottom: `1px solid ${borderColor}`, cursor: 'pointer',
                                background: vybrany ? SECTION_BG : 'transparent', boxShadow: vybrany ? `inset 3px 0 0 ${SECTION_COLOR}` : 'none',
                                opacity: r.stav === 'zrusena' ? 0.55 : 1,
                            }}>
                            <span style={{ width: 44, flexShrink: 0, fontSize: isMobile ? 15 : 13.5, fontWeight: 700, color: 'var(--text-primary)', fontVariantNumeric: 'tabular-nums' }}>
                                {r.cely_den ? 'den' : cas(r.zacatek)}
                            </span>
                            <div className="flex-1 min-w-0">
                                <p className="truncate" style={{ margin: 0, fontSize: isMobile ? 15 : 13.5, fontWeight: 600, color: 'var(--text-primary)' }}>{r.jmeno}</p>
                                <p className="truncate" style={{ margin: '2px 0 0', fontSize: isMobile ? 12.5 : 11.5, color: mutedColor }}>
                                    {[cil(r), r.cely_den || r.vice_dnu ? oknoPopis(r) : null, r.telefon].filter(Boolean).join(' · ')}
                                </p>
                            </div>
                            {r.serie_id && <Repeat size={13} style={{ color: mutedColor, flexShrink: 0 }} aria-label="Opakovaná rezervace" />}
                            {r.poznamka && <StickyNote size={13} style={{ color: mutedColor, flexShrink: 0 }} aria-label="Má poznámku" />}
                            <span className="flex items-center" style={{ gap: 3, fontSize: 12.5, fontWeight: 600, color: 'var(--text-secondary)', flexShrink: 0 }}>
                                <Users size={13} />{r.pocet_hostu}
                            </span>
                            <span className="rounded-full" style={{ padding: '2px 8px', fontSize: 10.5, fontWeight: 600, background: `${s.color}26`, color: s.color, flexShrink: 0 }}>
                                {s.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        );
    });
}
